<template>
  <div style="min-height:200px;">
    <div
      v-if="index == 0 && user && !imagesSceleton"
      style="position:absolute; left:-300px; width:276px;"
    >
      <input ref="fileInput" style="display:none" type="file" @change="createItem">
      <v-hover>
        <v-card
          slot-scope="{ hover }"
          style="background-color:rgba(0,0,0,0);border-radius:4px;user-select: none;"
          :class="[`elevation-${hover ? 12 : 0}`, {'white':hover}]"
          @click="loading?null:$refs.fileInput.click()"
        >
          <v-layout>
            <v-flex xs5 py-3 pr-2 :class="{'pl-3':hover}" style="transition: all 0.5s;">
              <div
                :class="[`elevation-${!hover ? 2 : 0}`, {'border-radius':!hover}]"
                style="display:flex;justify-content:center;align-items:center;height:125px; width:125px;background-color:rgba(0,0,0,0.4)"
              >
                <v-icon v-if="!loading" x-large dark>add</v-icon>
                <v-progress-circular v-else indeterminate color="white"></v-progress-circular>
              </div>
            </v-flex>
            <v-flex xs7>
              <v-card-title primary-title>
                <div
                  style="transition: all 0.5s;"
                  class="name pl-2"
                  :class="{'text-truncate':!hover, 'pl-4':hover && !item.url}"
                >
                  Ajouter
                  <br>un(e)
                  <br>artiste
                </div>
              </v-card-title>
            </v-flex>
          </v-layout>
        </v-card>
      </v-hover>
    </div>
    <v-hover v-if="item.date">
      <v-card
        slot-scope="{ hover }"
        style="background-color:rgba(0,0,0,0);border-radius:4px;"
        :class="[`elevation-${hover ? 12 : 0}`, {'white':hover, 'no-text': !item.name && !item.speciality && !user}]"
        target="_blank"
        :href="user?null:item.website"
      >
        <v-layout v-if="user" wrap row>
          <v-flex xs5 py-3 pr-2 :class="{'pl-3':hover}" style="transition: all 0.5s;">
            <v-img
              :class="[`elevation-${!hover ? 2 : 0}`, `rotate-${item.rotate}`, {'border-radius':!hover}]"
              :src="item.thumbnailUrl"
              :lazy-src="item.thumbnailUrl"
              height="125"
              width="125"
              style="position:relative;"
              class="slow-rotation"
              @click="rotate(item)"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
              <v-btn
                style="transform:scaleX(-1);position:absolute;top:33px;left:33px;z-index:6;opacity:1"
                icon
                dark
                @click
                large
                v-if="user && hover"
              >
                <v-icon color="white" class="shadow">rotate_90_degrees_ccw</v-icon>
              </v-btn>
            </v-img>
          </v-flex>
          <v-flex xs12 pa-3>
            <div>
              <v-text-field placeholder="Nom" class="title-item" v-model="item.name"></v-text-field>
              <v-text-field placeholder="Spécialité" v-model="item.speciality"></v-text-field>
              <v-text-field placeholder="Site Web" v-model="item.website"></v-text-field>
              <div style="text-align:center; width:100%;">
                <v-btn
                  class="text-none primary"
                  round
                  flat
                  @click="updateItem({category: category, item:item})"
                  :loading="loading"
                >Sauvegarder</v-btn>
                <v-btn
                  outline
                  round
                  class="text-none"
                  @click="deleteItem({category: category, item:item})"
                  :loading="loading"
                >Supprimer</v-btn>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout v-else>
          <v-flex xs5 py-3 pr-2 :class="{'pl-3':hover}" style="transition: all 0.5s;">
            <v-img
              :class="[`elevation-${!hover ? 2 : 0}`, {'border-radius':!hover}]"
              :src="item.thumbnailUrl"
              :lazy-src="item.thumbnailUrl"
              height="125"
              width="125"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </v-flex>
          <v-flex xs7>
            <div>
              <v-card-title>
                <div
                  style="transition: all 0.5s;"
                  class="name"
                  :class="{'text-truncate':!hover}"
                >{{ item.name }}</div>
              </v-card-title>
              <v-card-title class="my-0 py-0">
                <div
                  style="transition: all 0.5s;"
                  :class="{'text-truncate':!hover}"
                >{{ item.speciality }}</div>
              </v-card-title>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Artist",
  props: ["item", "type", "index", "category"],
  computed: {
    ...mapState(["user", "imagesSceleton", "loading"])
  },
  methods: {
    rotate(item) {
      item.rotate ? null : (item.rotate = 0);
      item.rotate < 270 ? (item.rotate = item.rotate + 90) : (item.rotate = 0);
      this.$store.commit("setLoading", true);
      this.$store.commit("setLoading", false);
    },
    createItem(event) {
      let data = {
        event: event,
        category: this.category
      };
      this.$store.dispatch("createItem", data);
    },
    deleteItem(data) {
      this.$store.dispatch("deleteItem", data);
    },
    updateItem(data) {
      let updatedItem = {
        category: data.category,
        item: Object.assign(data.item, {
          rotate: data.item.rotate || 0,
          name: data.item.name || "",
          speciality: data.item.speciality || ""
        })
      };
      // console.log(updatedItem);
      this.$store.dispatch("updateItem", updatedItem);
    }
  }
};
</script>

<style scoped>
.no-text {
  width: 158px;
}
.padding-hover {
  padding-left: 20px;
}
.name {
  font-size: 20px;
}
.border-radius {
  border-radius: 4px;
}
.shadow {
  text-shadow: 0px 2px 5px #000000;
}
.slow-rotation {
  transition: all 0.5s;
}
</style>
